<template>
  <div class="IoInfoInDate">
    <section-date-search-panel :accessTo="'12'" @search="search" />
    <box class="mt-2" :title="$t('personelList')">
      <template slot="top-action-view">
        <v-icon
          v-if="list.length >= 0 && visiblePrint"
          @click="print"
          color="white"
          >mdi-printer</v-icon
        >
      </template>
      <div class="vacationList">
        <div v-if="list.length > 0">
          <personel-io-info-in-date-list-web
            :pagination="true"
            :list="list"
            class="hidden-sm-and-down"
            @onClick="onClick"
          />
          <personel-io-info-in-date-list-mob
            @onClick="onClick"
            :list="list"
            class="hidden-md-and-up"
          />
        </div>
        <div v-else>
          <empty-list />
        </div>
      </div>
    </box>
  </div>
</template>

<script>
import PersonelIoInfoInDateListMob from "../../components/personelOperationReport/PersonelIoInfoInDateList/PersonelIoInfoInDateListMob.vue";
import PersonelIoInfoInDateListWeb from "../../components/personelOperationReport/PersonelIoInfoInDateList/PersonelIoInfoInDateListWeb.vue";
import SectionDateSearchPanel from "../../components/personelOperationReport/SectionDateSearchPanel.vue";
import ResultType from "../../model/ResultType";
import EosUtils from "../../utils/EosUtils";
export default {
  components: {
    SectionDateSearchPanel,
    PersonelIoInfoInDateListWeb,
    PersonelIoInfoInDateListMob,
  },
  data() {
    return {
      list: [],
      visiblePrint: false,
      iDate: "",
      sectionCode: "",
    };
  },
  methods: {
    search(searchParams) {
      this.list = [];
      this.iDate = searchParams.iDate;
      this.sectionCode = searchParams.sectionCode;

      var params = searchParams;
      this.$store.dispatch("GetIoInfoInDate", { params }).then((result) => {
        //console.log(result);
        if (result.type === ResultType.success) {
          this.list = result.data;
          this.checkVisiblePrint();
        }
      });
    },
    async checkVisiblePrint() {
      if (!EosUtils.isWebKartAdmin()) {
        var adminPermissionList =
          this.$store.state.personel.personelDetail.AdminPermission.Table;
        adminPermissionList.every((element) => {
          var adminPermission = element.adminPermission;
          console.log(adminPermission[50]);
          if (adminPermission && adminPermission[50].toString() == "1") {
            this.visiblePrint = true;
            return false;
          }
          return true;
        });
      } else {
        this.visiblePrint = true;
      }
    },
    print() {
      let routeData = this.$router.resolve({
        name: "rpIOInDate",
        query: { BD: this.iDate, SC: this.sectionCode },
      });
      window.open(routeData.href, "_blank");
    },
    onClick() {},
  },
};
</script>

<style>
</style>